import { createSelector } from 'reselect'
import { AppState } from 'store/types'

/**
 * @param state - the application state
 * @returns rosters - the rosters reducer
 */
export const selectRostersReducer = (state: AppState) => state.rosters

/**
 * Gets the rosters' data from the rosters reducer
 */
export const selectRosters = createSelector(
  selectRostersReducer,
  rostersState => rostersState.data,
)

/**
 * Gets the rosters' isFetching from the rosters reducer
 */
export const selectRostersIsFetching = createSelector(
  selectRostersReducer,
  rostersState => rostersState.isFetching,
)

/**
 * Gets the rosters' meta from the rosters reducer
 */
export const selectRostersMeta = createSelector(
  selectRostersReducer,
  rostersState => rostersState.meta,
)
